module.exports = __webpack_public_path__ + "img/1656.95d236d1.png";